/* eslint-disable react/display-name */
import ReactDOMServer from 'react-dom/server';
import styled, { ServerStyleSheet, StyleSheetManager } from 'styled-components';
import { GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
import SkeletonContainer from 'conversations-skeleton-state/components/SkeletonContainer';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import ViewSelectorSidebarSkeletonState from '../unified-inbox/components/ViewSelectorSidebarSkeletonState';
import ContactSidebarPlaceholder from '../unified-inbox/components/ContactSidebarPlaceholder';
import ThreadListMemberSidebarSkeletonState from '../thread-list-member-sidebar/components/ThreadListMemberSidebarSkeletonState';
import { CRM_BREAK_POINT, CRM_COLLAPSED_WIDTH } from '../crm-sidebar/constants';
import { tlmSidebarDynamicWidthStyles } from '../thread-list-member-sidebar/components/ThreadListMemberSidebarFrame';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import ThreadViewMessagePlaceholder from 'conversations-thread-view/thread-view/components/ThreadViewMessagePlaceholder';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import ThreadToolbarPlaceholder from 'conversations-thread-view/thread-toolbar/components/ThreadToolbarPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ATTR_BLOCKLIST = [
// remove this property since this isn't our main styled-components style tag
`data-hubspot-styled-components="true"`,
// remove this property to avoid AT conflicts
`data-test-id="reassignment-select-placeholder"`];
const ThreadViewMessageWrapper = styled.div.withConfig({
  displayName: "generateSkeletonState__ThreadViewMessageWrapper",
  componentId: "t7fztx-0"
})(["flex-direction:column;flex-grow:1;border-right:1px solid ", ";"], GREAT_WHITE);
const ThreadViewWrapper = styled.div.withConfig({
  displayName: "generateSkeletonState__ThreadViewWrapper",
  componentId: "t7fztx-1"
})(["height:100%;display:flex;flex-direction:column;flex-grow:1;border-right:1px solid ", ";"], GREAT_WHITE);
const ContactSidebarWrapper = styled.div.withConfig({
  displayName: "generateSkeletonState__ContactSidebarWrapper",
  componentId: "t7fztx-2"
})(["height:100%;min-width:280px;width:calc(32% - 2px);max-width:320px;@media (max-width:", "px){min-width:", "px;width:", "px;max-width:", "px;}"], CRM_BREAK_POINT, CRM_COLLAPSED_WIDTH, CRM_COLLAPSED_WIDTH, CRM_COLLAPSED_WIDTH);
const TLMSidebarWrapper = styled(SkeletonContainer).withConfig({
  displayName: "generateSkeletonState__TLMSidebarWrapper",
  componentId: "t7fztx-3"
})(["display:flex;flex-direction:column;height:100%;background-color:", ";border-right:1px solid ", ";", ""], OLAF, GREAT_WHITE, tlmSidebarDynamicWidthStyles);

/**
 * To use:
 *
 * The `ApplicationSkeletonState` component is what the preloader will look like - this should
 * match the inbox as best as possible. Whenever possible it should use the same placeholder
 * components we use in the inbox. Once this component has the desired appearance, call
 * the `generateSkeletonState` function. This will generate a string that contains all the HTML/CSS
 * for the preloader which will be logged into the console. This should then be copy/pasted into the
 * `rendered-skeleton-state.html` file.
 */

export const ApplicationSkeletonState = () => /*#__PURE__*/_jsx("div", {
  className: "admin-app-container",
  style: {
    marginTop: 60
  },
  role: "progressbar",
  "aria-busy": true,
  children: /*#__PURE__*/_jsxs(SkeletonContainer, {
    className: "flex-row",
    children: [/*#__PURE__*/_jsx(ViewSelectorSidebarSkeletonState, {}), /*#__PURE__*/_jsxs(TLMSidebarWrapper, {
      children: [/*#__PURE__*/_jsx(SkeletonContainer, {
        className: "p-left-4",
        height: 60,
        style: {
          minHeight: 60,
          borderBottom: `1px solid ${GREAT_WHITE}`
        },
        children: /*#__PURE__*/_jsx(SkeletonContainer, {
          className: "align-center",
          children: /*#__PURE__*/_jsx(SkeletonText, {
            width: 80
          })
        })
      }), /*#__PURE__*/_jsx(ThreadListMemberSidebarSkeletonState, {})]
    }), /*#__PURE__*/_jsxs(ThreadViewWrapper, {
      children: [/*#__PURE__*/_jsx(ThreadToolbarPlaceholder, {}), /*#__PURE__*/_jsxs(SkeletonContainer, {
        className: "flex-row",
        style: {
          height: '100%'
        },
        children: [/*#__PURE__*/_jsx(ThreadViewMessageWrapper, {
          children: /*#__PURE__*/_jsx(ThreadViewMessagePlaceholder, {})
        }), /*#__PURE__*/_jsx(ContactSidebarWrapper, {
          children: /*#__PURE__*/_jsx(ContactSidebarPlaceholder, {})
        })]
      })]
    })]
  })
});
export const generateSkeletonState = () => {
  const sheet = new ServerStyleSheet();
  let html;
  let styleTags;
  try {
    html = ReactDOMServer.renderToString( /*#__PURE__*/_jsx(StyleSheetManager, {
      sheet: sheet.instance,
      children: /*#__PURE__*/_jsx(ApplicationSkeletonState, {})
    }));
    styleTags = sheet.getStyleTags();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  } finally {
    sheet.seal();
  }
  const preloaderString = ATTR_BLOCKLIST.reduce((acc, x) => acc.replace(x, ''), `${html}\n${styleTags}`);

  // eslint-disable-next-line no-console
  console.log(preloaderString);
};